import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { WhatsAppButton } from "@/components/WhatsAppButton";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

export const Layout = ({ children }) => (
  <div className="flex min-h-screen flex-col bg-[#F7F4ED]">
    <ScrollToTop />
    <Header />
    <main className="flex-1" id="main-content">
      {children}
    </main>
    <Footer />
    <WhatsAppButton />
  </div>
);
